<script>
import Modal from "@/components/_Shared/Modal";
import Events from "./Events";

export default {
  components: {
    Events,
    Modal
  },

  data() {
    return {
      showEvents: false
    };
  },

  props: {
    events: {
      type: Array,
      required: true
    }
  }
};
</script>

<template>
  <div>
    <v-chip @click="showEvents = true">
      Histórico de eventos do pedido
    </v-chip>

    <Events
      :events="events"
      :enabled="showEvents"
      @close="showEvents = false"
    />
  </div>
</template>

<style scoped>
.v-chip {
  text-transform: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Orders/ShowOrder/Events/Index.vue